import { useRoute } from '@/composables/route'

/**
 * The company menu entries of the trial products, shared by AppSidebar, the legacy Header and the
 * MobileMenu so all three say the same (R8): the badge „Trial" only while a trial RUNS (never while
 * it can merely be started), on the Zentrale Asset-Bibliothek and on „Planung".
 */

/** startable, trial or null, from the shared `_damTrial` (HandleInertiaRequests). */
export const damTrialState = (page) => page.props._damTrial?.state ?? null

export const isDamTrialRunning = (page) => damTrialState(page) === 'trial'

export const isPlannerTrialRunning = (page) =>
  page.props._planner?.org?.trial?.state === 'trial'

/** The library entry also shows while its trial can be started (it then opens the Marketplace product). */
export const isDamEntryVisible = (page, hasLibrary) =>
  hasLibrary || damTrialState(page) === 'startable'

export const damEntryHref = (page) =>
  damTrialState(page) === 'startable'
    ? useRoute('marketplace.index', { product: 'dam' })
    : useRoute('dam.web.index')
